/* unplugin-vue-components disabled */import { render } from "./DialogView.vue?vue&type=template&id=f10fb6bc&scoped=true"
import script from "./DialogView.vue?vue&type=script&lang=js"
export * from "./DialogView.vue?vue&type=script&lang=js"

import "./DialogView.vue?vue&type=style&index=0&id=f10fb6bc&lang=scss&scoped=true"

import exportComponent from "/root/workspace/xhzj-pc_Z77T/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f10fb6bc"]])

export default __exports__